import { z } from 'zod';

/**
 * Base schema types for shared model definitions
 * These types work across API (Mongoose), Admin (Zustand), and App (Redux)
 */

// ObjectId - represented as string in frontend, converted to Schema.ObjectId in Mongoose
export const objectId = z.string().optional();
export const objectIdRequired = z.string();

// Common timestamp fields used across all models
export const timestampFields = {
  created: z.coerce.date().default(() => new Date()),
  updated: z.coerce.date().default(() => new Date()),
};

// Reference field - an ObjectId with a ref name for Mongoose population
export const refField = (refName: string) => ({
  schema: objectId,
  ref: refName,
});

export const refFieldRequired = (refName: string) => ({
  schema: objectIdRequired,
  ref: refName,
});

// Metadata for fields that need extra info for converters
export interface FieldMetadata {
  ref?: string;           // Mongoose ref for ObjectId fields
  label?: string;         // Human-readable label for UI
  headerName?: string;    // Short name for table headers
  editable?: boolean;     // Whether field is editable in UI
  width?: number;         // Column width for DataTable
  hidden?: boolean;       // Hide from DataTable
  agg?: string;           // Aggregate (per-game average) key derived from this raw
                          // stat field, e.g. points -> 'avgPoints'. Used to infer the
                          // public aggregate columns from the gameStats whitelist.
}

// Schema with metadata for converter utilities
export interface SchemaWithMetadata<T extends z.ZodTypeAny> {
  schema: T;
  metadata?: Record<string, FieldMetadata>;
}
